import { Phone } from "lucide-react";
import { Section } from "./Section";
import { FooterCallback } from "./FooterCallback";
import { useLocale } from "@/i18n/LocaleProvider";

/**
 * Låg tröskel-alternativ till kontaktformuläret: lämna namn och nummer så
 * ringer vi upp. Placeras på tunga sidor (priser, case, foto, ortssidor).
 */
export function CallbackBar({
  title,
  body,
  className,
}: {
  title?: string;
  body?: string;
  className?: string;
}) {
  const en = useLocale() === "en";
  return (
    <Section className={className ?? "py-10"}>
      <div className="mx-auto max-w-4xl rounded-3xl border border-white/10 bg-surface p-7 md:p-9">
        <div className="flex flex-col gap-6 md:flex-row md:items-center md:justify-between">
          <div className="max-w-md">
            <div className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.2em] text-mint">
              <Phone className="h-3.5 w-3.5" />
              {en ? "Prefer to talk?" : "Hellre prata?"}
            </div>
            <h2 className="mt-3 text-2xl font-semibold leading-tight">
              {title ?? (en ? "We'll call you back" : "Vi ringer upp er")}
            </h2>
            <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
              {body ??
                (en
                  ? "Leave your name and number — we call back during office hours, weekdays 08:30–17:00 (CET). No sales pitch, no commitment."
                  : "Lämna namn och nummer — vi ringer upp under kontorstid, vardagar 08:30–17:00. Ingen säljpitch, ingen bindning.")}
            </p>
            <p className="mt-3 text-sm text-foreground/80">
              {en ? "Or call us: " : "Eller ring oss: "}
              <a href="tel:+46848004706" className="font-medium text-mint hover:underline">
                08 480 047 06
              </a>
            </p>
          </div>
          <div className="w-full md:max-w-md">
            <FooterCallback />
          </div>
        </div>
      </div>
    </Section>
  );
}
